import { useMemo, useState } from 'react';
import {
	LiquidationDetailsDrawerDepositCards,
	LiquidationDetailsDrawerPerpsCards,
	LiquidationDetailsDrawerPnlCards,
} from 'src/components/Drawers/HistoryDrawers/LiquidationDetailsDrawer/LiquidationDetailsDrawerTable/LiquidationDetailsDrawerTableCards';
import Tabs from 'src/components/primitives/Tabs/Tabs';
import { TabOption } from 'src/components/primitives/Tabs/types';
import { AggregateLiqState } from 'src/hooks/Liquidations/useAggregateLiquidationDataForUser';

type LiqTabOption = 'perp' | 'deposits' | 'borrows' | 'unsettled';

const LIQ_TABS: TabOption<LiqTabOption>[] = [
	{
		label: 'Perps',
		value: 'perp',
	},
	{
		label: 'Deposits',
		value: 'deposits',
	},
	{
		label: 'Borrows',
		value: 'borrows',
	},
	{
		label: 'Unsettled P&L',
		value: 'unsettled',
	},
];

interface Props {
	liquidation: AggregateLiqState;
}

export default function LiquidationDetailsDrawerTable({ liquidation }: Props) {
	const defaultTab = (() => {
		if (liquidation.liqdPerps?.length > 0) {
			return 'perp';
		}

		if (liquidation.liqdBorrows?.length > 0) {
			return 'borrows';
		}

		return 'deposits';
	})();

	const [activeTab, setActiveTab] = useState<LiqTabOption>(defaultTab);

	const tabs = useMemo(() => {
		const tabs: TabOption<LiqTabOption>[] = [];

		if (liquidation.liqdPerps?.length > 0) {
			tabs.push(LIQ_TABS[0]);
		}

		if (liquidation.liqdDeposits?.length > 0) {
			tabs.push(LIQ_TABS[1]);
		}

		if (liquidation.liqdBorrows?.length > 0) {
			tabs.push(LIQ_TABS[2]);
		}

		return tabs;
	}, [liquidation]);

	return (
		<>
			<Tabs
				size="sm"
				variant="secondary"
				className="w-fit"
				options={tabs}
				activeTab={activeTab}
				onTabChange={setActiveTab}
			/>

			{activeTab === 'perp' && (
				<LiquidationDetailsDrawerPerpsCards data={liquidation} />
			)}
			{activeTab === 'deposits' && (
				<LiquidationDetailsDrawerDepositCards data={liquidation.liqdDeposits} />
			)}
			{activeTab === 'borrows' && (
				<LiquidationDetailsDrawerDepositCards data={liquidation.liqdBorrows} />
			)}
			{activeTab === 'unsettled' && (
				<LiquidationDetailsDrawerPnlCards data={liquidation.liqdPerpPnls} />
			)}
		</>
	);
}
